import { Component } from '@angular/core';
import { NzInputModule } from 'ng-zorro-antd/input';
@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss',
})
export class ComingSoonComponent {}
